var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaThinArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4015 7.08926C11.3406 7.15044 11.2681 7.19898 11.1883 7.2321C11.1086 7.26523 11.0231 7.28228 10.9367 7.28228C10.8503 7.28228 10.7648 7.26523 10.685 7.2321C10.6053 7.19898 10.5328 7.15044 10.4718 7.08926L7.65598 4.2734V12.3125C7.65598 12.4865 7.58684 12.6534 7.46377 12.7765C7.3407 12.8996 7.17378 12.9687 6.99973 12.9687C6.82568 12.9687 6.65876 12.8996 6.53569 12.7765C6.41262 12.6534 6.34348 12.4865 6.34348 12.3125V4.2734L3.52653 7.08926C3.40324 7.21254 3.23604 7.2818 3.06169 7.2818C2.88734 7.2818 2.72013 7.21254 2.59684 7.08926C2.47356 6.96597 2.4043 6.79876 2.4043 6.62441C2.4043 6.45006 2.47356 6.28285 2.59684 6.15957L6.53434 2.22207C6.59531 2.16089 6.66775 2.11235 6.74752 2.07923C6.82729 2.0461 6.91281 2.02905 6.99919 2.02905C7.08556 2.02905 7.17108 2.0461 7.25085 2.07923C7.33062 2.11235 7.40306 2.16089 7.46403 2.22207L11.4015 6.15957C11.4627 6.22054 11.5113 6.29298 11.5444 6.37275C11.5775 6.45252 11.5945 6.53804 11.5945 6.62441C11.5945 6.71079 11.5775 6.79631 11.5444 6.87608C11.5113 6.95584 11.4627 7.02829 11.4015 7.08926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaThinArrowUp);
export default __webpack_public_path__ + "static/media/fa-thin-arrow-up.6df2fe1b4317477a5dd4cc53583856ac.svg";
export { ForwardRef as ReactComponent };